export default "__VITE_ASSET__56f3bb73__"